import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import clsx from "clsx";
import {
  ITextBlockFields,
  SpecificLocaleFields,
} from "~/@types/generated/contentful";
import { getComponentFromContentfulRichTextEntry } from "~/contentful";
import {
  PageComponentData,
  useComponentData,
} from "~/contexts/ComponentDataProvider";

type TextBlockProps = {
  fields: SpecificLocaleFields<ITextBlockFields>;
  className?: string;
};

export default function TextBlock({ fields, className }: TextBlockProps) {
  if (!fields.backgroundColor) fields.backgroundColor = "white";
  const colSpan = `lg:col-span-${fields.columns}`;
  const colStart = `lg:col-start-${fields.columnStart}`;
  const { page } = useComponentData() as PageComponentData;
  return (
    <section
      id={fields.id}
      data-content-type="textBlock"
      data-module-title={fields.moduleTitle}
      className={clsx(className, {
        "text-white": ["black"].includes(fields.backgroundColor),
        "text-black": ["white", "slate"].includes(fields.backgroundColor),
        "bg-black": fields.backgroundColor === "black",
        "bg-white": fields.backgroundColor === "white",
        "bg-slate": fields.backgroundColor === "slate",
      })}
      style={{
        backgroundColor: fields.colorPalette?.fields.backgroundColor,
        color: fields.colorPalette?.fields.fontColor,
      }}
    >
      <div className="tbi-grid">
        {fields.body && (
          <div
            className={clsx(
              "[&_p]:body col-span-4 col-start-1 [&_p]:mt-6",
              colSpan,
              colStart,
              page && "[&_ul]:pt-0",
            )}
          >
            {documentToReactComponents(
              fields.body,
              getComponentFromContentfulRichTextEntry,
            )}
          </div>
        )}
      </div>
    </section>
  );
}
